import styled from 'styled-components';
import { transparentize } from 'polished';
import themeGet from '@styled-system/theme-get';

import { ButtonBase } from './Button';

export const PillButton = styled(ButtonBase)`
  color: ${themeGet('colors.primary.100')};
  padding: 8px 12px;
  align-items: center;
  display: flex;
  gap: 4px;
  border-radius: 32px;
  cursor: pointer;
  height: auto;
  background-color: ${props =>
    transparentize(0.96, themeGet('colors.primary.100')(props))};

  &:hover {
    span,
    i {
      color: ${themeGet('colors.white')};
    }
  }

  &:focus {
    span,
    i {
      color: ${themeGet('colors.primary.120')};
    }
  }
`;
